import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {HttpClientService} from "../../../core/services/http-client.service";
import {CommonService} from "../../../core/services/common.service";
import {ToastService} from "../../../core/services/toast.service";
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.css']
})
export class AddressesComponent implements OnInit{
  @Input() limit: any = 100;
  @Input() activeOption: any = 'Remove';
  @Input() visible: boolean = false;
  @Input() visibledel: boolean = false;
  @Output() getAddressData = new EventEmitter<any>();
  addresses: any[] = [];
  constructor(private http: HttpClientService, private common: CommonService, private toast: ToastService) {}
  addressForm: any = {
    name: '',
    lastName: '',
    phoneNumber: '',
    line1: '',
    line2: '',
    landmark: '',
    city: '',
    state: '',
    pinCode: '',
    active: true
  };
  user: any;
  selectedAddress: any;
  selectedAddressId:any

  ngOnInit(): void {
    this.user = this.common.getStorage('customer');
    this.getUserAddresses(this.user.id);
    this.addressForm.customerId=this.user.id;
  }

  private getUserAddresses(userID) {
    this.http.get(`store/addresses/${userID}`)
      .subscribe((res) => {
        if (res.statusCode == 200) {
          this.addresses = res.response.map(address => ({
            ...address,
            fullAddress: this.getFullAddress(address)
          }));

          // Sort addresses to ensure default comes first
          this.addresses.sort((a, b) => b.default - a.default);

          // Select the default address if available
          const defaultAddress = this.addresses.find(addr => addr.default);
          if (defaultAddress) {
            this.selectAddress(defaultAddress);
          }
        }
      });
  }


  createUserAddresses() {
    this.http.post( `store/address`,this.addressForm).subscribe(
      (res: any) => {
        if (res.statusCode == 200){
          this.getUserAddresses(this.addressForm.customerId);
          this.addressForm = {
            name: '',
            lastName: '',
            phoneNumber: '',
            line1: '',
            line2: '',
            landmark: '',
            city: '',
            state: '',
            pinCode: '',
            active: true,
            customerId: this.user.id
          };
          this.toast.success("Address Created Successfully ");
        }

      },
      (error) => {
        console.error('Error creating address:', error);
      }
    );
  }
  confirmDelete(addressId: string) {
    this.selectedAddressId = addressId;
    this.visibledel = true;
  }
  deleteAddress(selectedAddressId) {
    this.http.post("/store/deactivateCustomerAddress?id=" + selectedAddressId).subscribe(data => {
      if (data['responseStatus'].toLowerCase() == 'success') {
        this.toast.success('Address deleted');
        this.getUserAddresses(this.addressForm.customerId);
      } else {
      }
    }, error => {
        this.toast.success(error);
    });
    this.visibledel=false;
  }

  selectAddress(address){
    this.selectedAddress = address; // Update the selected address
    this.getAddressData.emit(address)
  }
  selectDefaultAddress(address){
    this.http.post(`store/address/defaultAddress/${address.id}/${this.user.id}`,{}).subscribe(data => {
      if (data['responseStatus'].toLowerCase() == 'success') {
        this.toast.success('Address selected');
        this.getUserAddresses(this.addressForm.customerId);
      }
    }, error => {
      this.toast.success(error);
    });
    this.visibledel=false;
  }
  getFormData(address: any) {
    this.addressForm  = address
    this.createUserAddresses();
    this.visible = false;
  }

  getFullAddress(address: any) {
    let add = '';
    add += address.line1 ? address.line1+', ' : ''
    add += address.line2 ? address.line2+', ' : ''
    add += address.landmark ? address.landmark+', ' : ''
    add += address.city ? address.city+', ' : ''
    add += address.state ? address.state+', ' : ''
    add += address.pinCode ? address.pinCode : ''
    return add;
  }
}
